import { useEffect, useState } from 'react';
import { Wrapper } from './style';

import Electricity from '../../Components/Electricity';
import { subTabs } from './constants';
import TabContent from '../Navigation/TabContent';
import { useNavigate } from 'react-router-dom';

export default function Component({ className = '', moreList, setMoreList,subActiveTab,setSubActiveTab }) {
  
  const navigator = useNavigate();
	const ChangeSubTabs = (id) => {
		setSubActiveTab(id);
		
	};

	useEffect(()=>{
navigator("/bbps-services")
	},[])
	const tabContentMap = {
		subTab1: <Electricity className="electricity-form" BillType={'GAS'} billHeading={'Gas'} />,
		subTab2: <Electricity className="electricity-form" BillType={'LANDLINE'} billHeading={'LANDLINE'} />,
		subTab3: <Electricity className="electricity-form" BillType={'INSURANCE'} billHeading={'Insurance'} />,
		subTab4: <Electricity className="electricity-form" BillType={'EMI'} billHeading={'EMI'} />,
		subTab5: <Electricity className="electricity-form" BillType={'OTT'} billHeading={'OTT'} />,
		subTab6: <Electricity className="electricity-form" BillType={'LPG'} billHeading={'Gas Cylinder'} />,
		subTab7: <Electricity className="electricity-form" BillType={'FASTAG'} billHeading={'Fasttag'} />,
		subTab8: <Electricity className="electricity-form" BillType={'METRO'} billHeading={'Metro'} />,
		subTab9: <Electricity className="electricity-form" BillType={'CABLE_TV'} billHeading={'Cable TV'} />,
		subTab10: <Electricity className="electricity-form" BillType={'APARTMENT'} billHeading={'Apartment'} />,
		subTab11: <Electricity className="electricity-form" BillType={'WATER'} billHeading={'Water'} />,
	};

	return (
		<>
			{/* {moreList && (
				<Wrapper className={className}>
					<div className="inner-form">
						{subTabs.map((value, i) => {
							return (
								<>
									{value.services?.length > 0 && (
										<h2 key={i} className="service-heading">
											{value.title}
										</h2>
									)}
									{value?.services?.length > 0 &&
										value.services.map((service, index) => {
											return (
												<div key={index} id={value.id} onClick={() => ChangeSubTabs(service.id)} className={subActiveTab === service.id ? 'subTab active' : 'subTab'}>
													<div className="subtab-icon">
														<img src={service.icon} alt={service.title} />
													</div>
													<div className="subtab-title">{service.title}</div>
												</div>
											);
										})}
								</>
							);
						})}
					</div>
				</Wrapper>
			)}
			{Object.keys(tabContentMap).map((subTabId, i) => {
				return (
					<TabContent id={subTabId} activeTab={subActiveTab}>
						{tabContentMap[subTabId]},gjgdcu
					</TabContent>
				);
			})} */}
		</>
	);
}
